const getOneTimeLoginLink = () => {};

export default getOneTimeLoginLink;
